import { render } from "./updater.vue?vue&type=template&id=7fd47664"
import script from "./updater.vue?vue&type=script&lang=js"
export * from "./updater.vue?vue&type=script&lang=js"

import "./updater.vue?vue&type=style&index=0&id=7fd47664&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__